/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Codec_LabelInputs */

const en_audio_embed_export_codec_label = /** @type {(inputs: Audio_Embed_Export_Codec_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio codec`)
};

const fr_audio_embed_export_codec_label = /** @type {(inputs: Audio_Embed_Export_Codec_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codec audio`)
};

const de_audio_embed_export_codec_label = /** @type {(inputs: Audio_Embed_Export_Codec_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio-Codec`)
};

const it_audio_embed_export_codec_label = /** @type {(inputs: Audio_Embed_Export_Codec_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codec audio`)
};

const ru_audio_embed_export_codec_label = /** @type {(inputs: Audio_Embed_Export_Codec_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиокодек`)
};

const es_audio_embed_export_codec_label = /** @type {(inputs: Audio_Embed_Export_Codec_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`códec de audio`)
};

const zh_cn2_audio_embed_export_codec_label = /** @type {(inputs: Audio_Embed_Export_Codec_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频编解码器`)
};

const ja_audio_embed_export_codec_label = /** @type {(inputs: Audio_Embed_Export_Codec_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオコーデック`)
};

const hi_audio_embed_export_codec_label = /** @type {(inputs: Audio_Embed_Export_Codec_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो कोडेक`)
};

const pt_pt2_audio_embed_export_codec_label = /** @type {(inputs: Audio_Embed_Export_Codec_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codec de áudio`)
};

/**
* | output |
* | --- |
* | "Audio codec" |
*
* @param {Audio_Embed_Export_Codec_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_codec_label = /** @type {((inputs?: Audio_Embed_Export_Codec_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Codec_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_codec_label(inputs)
	if (locale === "de") return de_audio_embed_export_codec_label(inputs)
	if (locale === "it") return it_audio_embed_export_codec_label(inputs)
	if (locale === "ru") return ru_audio_embed_export_codec_label(inputs)
	if (locale === "es") return es_audio_embed_export_codec_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_codec_label(inputs)
	if (locale === "ja") return ja_audio_embed_export_codec_label(inputs)
	if (locale === "hi") return hi_audio_embed_export_codec_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_codec_label(inputs)
	return en_audio_embed_export_codec_label(inputs)
});